import { z } from 'zod/v4';
import { contentStatusEnum as contentStatusSchema, type ContentStatus } from '../enums/index';

export const createPostSchema = z.object({
  content: z.string({ message: 'Содержимое поста обязательно' })
    .min(1, 'Содержимое поста не может быть пустым')
    .max(10000, 'Содержимое поста слишком длинное (максимум 10000 символов)'),
  imageIds: z.array(z.number().int('ID изображения должен быть целым числом'))
    .max(10, 'Максимум 10 изображений')
    .optional(),
});

export const updatePostSchema = z.object({
  content: z.string()
    .min(1, 'Содержимое поста не может быть пустым')
    .max(10000, 'Содержимое поста слишком длинное (максимум 10000 символов)')
    .optional(),
  imageIds: z.array(z.number().int('ID изображения должен быть целым числом'))
    .max(10, 'Максимум 10 изображений')
    .optional(),
});

export const postFiltersSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number()
    .int('Лимит должен быть целым числом')
    .min(1, 'Лимит должен быть >= 1')
    .max(50, 'Лимит должен быть <= 50')
    .default(20),
  status: contentStatusSchema.optional(),
});

export type CreatePostDto = z.infer<typeof createPostSchema>;
export type UpdatePostDto = z.infer<typeof updatePostSchema>;
export type PostFiltersDto = z.infer<typeof postFiltersSchema>;

// Re-export ContentStatus for backward compatibility
export type { ContentStatus };
